import React, { useState } from 'react';
import logo from '../../images/logo.webp';
import { MdAccountCircle } from 'react-icons/md';
import { Link, useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { RxHamburgerMenu } from 'react-icons/rx';
import { IoClose } from 'react-icons/io5';
import { signOut } from '../../../Redux/features/auth/authSlice';
import { useDispatch } from 'react-redux';
import { reset as resetOrder } from '../../../Redux/features/order/orderSlice';
import { reset as resetStock } from '../../../Redux/features/Stock/stockSlice';

const AdminNavBar = () => {
	const [isMenuOpen, setIsMenuOpen] = useState(false);
	const [isDropdownOpen, setIsDropdownOpen] = useState(false);
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const location = useLocation();

	// Toggle for mobile menu
	const toggleMenu = () => {
		setIsMenuOpen((prevState) => !prevState);
	};

	// Toggle for dropdown menu
	const toggleDropdown = () => {
		setIsDropdownOpen((prevState) => !prevState);
	};

	// Logout handler
	const handleLogout = () => {
		dispatch(signOut());
		dispatch(resetOrder());
		dispatch(resetStock());
		navigate('/');
	};

	// Function to strip query params from a URL and only compare the path
	const getPathnameWithoutQuery = (url) => {
		// Create a URL object to parse the given URL
		const urlObj = new URL(url, window.location.origin); // Adding window.location.origin as a fallback base

		// Normalize path by removing trailing slashes
		const normalizePath = (path) => {
			return path.replace(/\/$/, ''); // Removes trailing slashes
		};

		// Get the pathname without query or hash
		const pathnameWithoutQuery = normalizePath(urlObj.pathname);

		// Return the normalized pathname
		return pathnameWithoutQuery;
	};

	return (
		<>
			<div className='flex px-4 pt-5 h-16 w-full justify-between items-center sticky bg-white z-10'>
				{/* Hamburger Menu */}
				<div className='flex justify-center items-center'>
					<button className='text-xl md:hidden' onClick={toggleMenu}>
						<RxHamburgerMenu />
					</button>
					{/* Logo Section */}
					<div className='pl-5 block'>
						<Link to='/'>
							<img
								src={logo}
								alt='Logo'
								className='w-16 object-cover aspect-auto max-[440px]:w-12'
							/>
						</Link>
					</div>
				</div>
				{/* Desktop Navigation */}
				<div className='hidden md:flex'>
					<ul className='flex flex-row lg:gap-8 gap-4 font-semibold'>
						{[
							{ name: 'Home', link: '/adminhome' },
							{ name: 'Add Article', link: '/upload' },
							{ name: 'Manage Catalog', link: '/manageCatalog' },
							{ name: 'Manage Article', link: '/managearticle' },
							{ name: 'Order DashBoard', link: '/orderdashboard' },
							{ name: 'User Request', link: '/userrequest' },
						].map((item) => {
							// Compare the current pathname without query parameters to determine if the link is active
							const isActive = getPathnameWithoutQuery(location.pathname) === item.link;
							return (
								<li key={item.name} className={`cursor-pointer ${isActive ? 'text-red-500' : ''}`}>
									<Link to={item.link}>{item.name}</Link>
								</li>
							);
						})}
					</ul>
				</div>

				{/* Profile and Mobile Menu */}
				<div className='flex flex-row items-center gap-4'>
					{/* Profile Dropdown */}
					<div className='relative'>
						<MdAccountCircle
							className='text-[25px] md:text-3xl cursor-pointer'
							onClick={toggleDropdown}
						/>
						{isDropdownOpen && (
							<ul className='absolute right-0 mt-2 bg-white shadow-xl rounded w-40'>
								<li>
									<button
										onClick={handleLogout}
										className='block w-full text-left p-2 text-sm hover:text-red-500 font-medium'>
										Logout
									</button>
								</li>
							</ul>
						)}
					</div>
				</div>
			</div>

			{/* Mobile Sliding Menu */}
			<div
				className={`fixed top-0 left-0 h-full bg-white shadow-md transition-transform transform ${
					isMenuOpen ? 'translate-x-0' : '-translate-x-full'
				} z-50`}
				style={{ width: '75%' }}>
				<div className='flex justify-between items-center p-4'>
					<Link
						to='/adminhome'
						onClick={() => {
							setIsMenuOpen(false);
						}}>
						<img src={logo} alt='' className='w-16 mb-2 hidden min-[400px]:block' />
					</Link>
					<button onClick={toggleMenu} className='text-2xl'>
						<IoClose />
					</button>
				</div>
				<ul className='flex flex-col p-5'>
					{[
						{ name: 'Home', link: '/adminhome' },
						{ name: 'Add Article', link: '/upload' },
						{ name: 'Manage Catalog', link: '/manageCatalog' },
						{ name: 'Manage Article', link: '/managearticle' },
						{ name: 'Order DashBoard', link: '/orderdashboard' },
						{ name: 'User Request', link: '/userrequest' },
					].map((item) => {
						// Compare the current pathname without query parameters to determine if the link is active
						const isActive = getPathnameWithoutQuery(location.pathname) === item.link;
						return (
							<li
								className={`cursor-pointer mb-2 ${isActive ? 'text-red-500' : ''}`}
								key={item.name}>
								<Link
									to={item.link}
									onClick={() => {
										setIsMenuOpen(false);
									}}>
									{item.name}
								</Link>
							</li>
						);
					})}
				</ul>
			</div>
		</>
	);
};

export default AdminNavBar;
